import { Button } from '@/components/Button';
import { CHAIN_ID } from '@/constants/chain';
import { useWalletChainId } from '@/features/wallet/hook';
import SwitchNetworkButton from '@/pages/components/WalletStatus/SwitchNetworkButton';
import { WALLET_CONNECT_STATUS } from '@/types/wallet';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import './index.less';

interface IPropTypes {
  onWithdraw: () => void;
  onLater: () => void;
  isLoading?: boolean;
}

const BlastWithdrawFooter: FC<IPropTypes> = ({ onWithdraw, onLater, isLoading }) => {
  const { t } = useTranslation();
  const currentChainId = CHAIN_ID.BLAST;
  const walletChainId = useWalletChainId();

  const walletConnectStatus = useMemo(
    () => (walletChainId === currentChainId ? WALLET_CONNECT_STATUS.CONNECTED : WALLET_CONNECT_STATUS.WRONG_NETWORK),
    [walletChainId, currentChainId],
  );

  return (
    <div className="syn-blast-withdraw-footer">
      {walletConnectStatus === WALLET_CONNECT_STATUS.WRONG_NETWORK && <SwitchNetworkButton chainId={currentChainId} />}
      {walletConnectStatus === WALLET_CONNECT_STATUS.CONNECTED && (
        <Button className="syn-blast-withdraw-btn" type="primary" onClick={onWithdraw} loading={isLoading} block>
          {t('common.withdraw')}
        </Button>
      )}
      <div className="syn-blast-withdraw-later" onClick={onLater}>
        Later
      </div>
    </div>
  );
};

export default BlastWithdrawFooter;
